<!-- 払い戻し手数料 -->
<template>
  <div class="column">
    <!-- 料金 -->
    <label class="name">{{ $t("MyTicketTicketing.serviceCharge") }}</label>

    <!-- 金額 -->
    <div class="value">{{ charge }}{{ $t("common.unit") }}</div>
  </div>
</template>

<script>
export default {
  name: "BgRefundServiceCharge",
  props: {
    charge: {
      type: Number,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
